import { URL_SRV_ARIZTIA } from '../../router/Url';

export const GetStatusBroker = () => {
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'getstatus_broker',{
            method: 'POST',
            headers: {
                'authorization': "paico2021",
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            // body: JSON.stringify({
            //     DATA
            // })
        })
        let responsito = await query.json();
        // console.log(responsito)

        if(responsito.success){
            resolve(responsito.body)
        }else{
            resolve([])
        }
    })
}
